export default __webpack_public_path__ + "static/media/ktp benar.a4c43410.jpg";